import { ScreenFields } from '@/components/ScreenForm/ScreenFields'
import type { ScreenField } from '@/components/ScreenForm/screenForm'
import { useScreenForm } from '@/components/ScreenForm/useScreenForm'
import { Button } from '@/components/ui/button'
import type { ChatActionWithValue } from '../../models/chat'

interface ChatScreenFormProps {
  fields: ScreenField[]
  handleSubmit: (data: ChatActionWithValue | FormData) => void
  readonly?: boolean
}

/** One screen of a non-trucking application, answered together and sent as one chat answer. */
export function ChatScreenForm({ fields, handleSubmit, readonly }: ChatScreenFormProps) {
  const form = useScreenForm(fields)

  return (
    <form
      noValidate
      className="flex w-full flex-col gap-6"
      onSubmit={(event) => {
        event.preventDefault()
        if (readonly || !form.validate()) return
        handleSubmit({
          content: { component: 'P', content: form.summary() || 'Nothing to add' },
          value: form.payload(),
        })
      }}
    >
      <ScreenFields form={form} disabled={readonly} />
      {!readonly && (
        <div className="flex justify-end">
          <Button type="submit">Continue</Button>
        </div>
      )}
    </form>
  )
}
